import { TmdxAvatar, Tooltip } from '@ds';
import { ConditionalRender } from '@ui';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { getLocationAddress } from '@/utils/helpers';
import { CaseFacility } from '@/api/apis/case';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

interface FacilityRowsProps {
  facilityDetails?: CaseFacility | null;
  label?: string;
  addressLabel?: string;
}

export const FacilityRows = ({ facilityDetails, label = 'Hospital', addressLabel = 'Address' }: FacilityRowsProps) => {
  const { resolveSubdivisionName } = useCountriesData();
  const fullAddress = getLocationAddress(facilityDetails?.location, resolveSubdivisionName);

  return (
    <>
      <SectionRow label={label}>
        <ConditionalRender show={!!facilityDetails} placeholder="-">
          <div className="flex gap-2 items-center">
            <TmdxAvatar
              type="facility"
              size="lg"
              radius="md"
              src={facilityDetails?.logoPath}
              name={
                facilityDetails?.code ||
                resolveSubdivisionName(facilityDetails?.location?.state, facilityDetails?.location?.country)
              }
              fallbackInitials={false}
            />
            <Tooltip className="text-m-r!" content={facilityDetails?.name} showArrow>
              <span className="truncate min-w-0">{facilityDetails?.name}</span>
            </Tooltip>
          </div>
        </ConditionalRender>
      </SectionRow>
      <SectionRow label={addressLabel}>
        <ConditionalRender show={!!facilityDetails} placeholder="-">
          <Tooltip className="text-m-r!" content={fullAddress} showArrow>
            <div className="truncate min-w-0">{fullAddress}</div>
          </Tooltip>
        </ConditionalRender>
      </SectionRow>
    </>
  );
};
